import React from 'react';
import SubmitCommonComponent from './SubmitCommonComponent';
import { FeedbackType, SubmitProps } from './utils';
import { FeedbackStatus } from 'donor/portal/pages/FeedbackDashboard/api';
import { useReport } from 'shared/providers/ReportProvider';

const subheading =
  'Thanks for responding to all of your feedback. Once you send your responses, we’ll double check for anything else needed before ' +
    'we hit the publish button. We’ll let you know either way!';

const subheadingThirdParty =
  'Thanks for resolving to all of your feedback. You can now submit your report!';

const getNextReportStatus = (
  isThirdPartyReport: boolean,
  feedbackType: FeedbackType,
  feedbackStatus: FeedbackStatus,
  isReportEndDatePassed: boolean,
): FeedbackStatus => {
  if (isThirdPartyReport) {
    return 'Finalized';
  }
  if (feedbackType === 'Donor Only') {
    return 'Awaiting Funder Verification';
  }
  return 'Awaiting TI Verification';
};

type NPOSubmitsProps = SubmitProps

const NPOSubmits: React.FC<NPOSubmitsProps> = ({
  feedbackType,
  feedbackStatus,
  isLoading,
  errorMessage,
  onDone,
  handleBack,
  className,
  isThirdPartyReport,
}) => {
  const { isReportEndDatePassed } = useReport();
  const onClick = () =>
    onDone(
      getNextReportStatus(
        isThirdPartyReport,
        feedbackType,
        feedbackStatus,
        isReportEndDatePassed,
      ),
    );
  return (
    <SubmitCommonComponent
      heading="Great job!"
      subheading={isThirdPartyReport ? subheadingThirdParty : subheading}
      onClick={onClick}
      isLoading={isLoading}
      errorMessage={errorMessage}
      buttonText={isThirdPartyReport ? 'Publish report' : 'Send responses'}
      className={className}
      handleBack={handleBack}
    />
  );
};

export default NPOSubmits;
